<ion-menu contentId="main-content" [swipeGesture]="false">
  <!--  <ion-header>-->
  <!--    <ion-toolbar>-->
  <!--    </ion-toolbar>-->
  <!--  </ion-header>-->
  <ion-content>
    <ion-list lines="none">
      <div class="title">
        <img src="assets/logo-black.svg" class="logo" alt="logo seculib" />
        <span class="text">Seculib</span>
      </div>

      <ion-item-divider></ion-item-divider>

      <div class="identity ion-padding">
        <div class="icon-container">
          <ion-icon name="person-circle-outline" color="dark" aria-label="Identity"></ion-icon>
        </div>
        <span>{{ user()?.designation }}</span>
        <ion-menu-toggle>
          <ion-button (click)="logout()" fill="clear">
            <ion-icon name="log-out-outline" color="dark" aria-label="Logout"></ion-icon>
          </ion-button>
        </ion-menu-toggle>
      </div>

      <ion-item-divider></ion-item-divider>

      <div class="section-title ion-padding">À traiter</div>
      <ion-menu-toggle routerLink="/home" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" class="ion-padding">
        <div class="icon-container">
          <ion-icon class="active-icon" name="home"></ion-icon>
          <ion-icon class="inactive-icon" name="home-outline"></ion-icon>
        </div>
        <span>Accueil</span>
      </ion-menu-toggle>
      <ion-menu-toggle
        routerLink="/home-responsable"
        [queryParams]="{ tab: 'alertes' }"
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: false, queryParams: 'subset', fragment: 'ignored', matrixParams: 'ignored' }"
        class="ion-padding"
      >
        <div class="icon-container">
          <ion-icon class="active-icon" name="notifications"></ion-icon>
          <ion-icon class="inactive-icon" name="notifications-outline"></ion-icon>
        </div>
        <span>Alertes</span>
      </ion-menu-toggle>
      <ion-menu-toggle
        routerLink="/liste-demandes-recues"
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: true }"
        class="ion-padding"
        [class.attention]="isResponsable() && missionsATraiterCount() > 0"
      >
        <div class="icon-container">
          <ion-icon class="active-icon" name="mail"></ion-icon>
          <ion-icon class="inactive-icon" name="mail-outline"></ion-icon>
        </div>
        <span>Demandes à affecter</span>
        @if (isResponsable()) {
          @if (missionsATraiterCount() > 0) {
            <div class="badge">{{ missionsATraiterCount() }}</div>
          }
        } @else {
          @if (currentCreneauService.nbInterPonctuelles() > 0) {
            <div class="badge">{{ currentCreneauService.nbInterPonctuelles() }}</div>
          }
        }
      </ion-menu-toggle>

      <div class="section-title ion-padding">Gestion</div>
      <ion-menu-toggle routerLink="/pointeaux" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" class="ion-padding">
        <div class="icon-container">
          <ion-icon class="active-icon" name="qr-code"></ion-icon>
          <ion-icon class="inactive-icon" name="qr-code-outline"></ion-icon>
        </div>
        <span>Gestion des pointeaux</span>
      </ion-menu-toggle>
    </ion-list>
  </ion-content>
  <ion-footer>
    <ion-list lines="none">
      <ion-menu-toggle routerLink="/preferences" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" class="ion-padding">
        <div class="icon-container">
          <fa-icon class="active-icon" [icon]="faGear"></fa-icon>
          <fa-icon class="inactive-icon" [icon]="faGearOutline"></fa-icon>
        </div>
        <span>Préférences</span>
      </ion-menu-toggle>
      <ion-menu-toggle class="ion-padding" (click)="openWebapp()">
        <div class="icon-container">
          <ion-icon name="open-outline"></ion-icon>
        </div>
        <span>Ouvrir l'application web</span>
      </ion-menu-toggle>
    </ion-list>
  </ion-footer>
</ion-menu>
